import React from 'react';
import BulletinInfo from './property-info/BulletinInfo';
import ProjectInfo from './property-info/ProjectInfo';
import CommercialBulletinInfo from './property-info/CommercialBulletinInfo';
import CommercialProjectInfo from './property-info/CommercialProjectInfo';
import * as Styled from './styled';
import FavouritesToggle from '../../components/FavouritesCardButton';
import { ListViewCardProps } from '../';
import { CardType } from 'components/cards/types';
import { DiscountTagline } from '../../styled';


const ListViewCard: React.FC<ListViewCardProps> = (props) => {
  let propertyInfo = null;

  switch (props.cardType) {
    case CardType.Bulletin:
      propertyInfo = <BulletinInfo {...props} />;
      break;
    case CardType.Project:
      propertyInfo = <ProjectInfo {...props} />;
      break;
    case CardType.CommercialBulletin:
      propertyInfo = <CommercialBulletinInfo {...props} />;
      break;
    case CardType.CommercialProject:
      propertyInfo = <CommercialProjectInfo {...props} />;
      break;
  }

  const tagline = props.allowToShowTagline && (props.cardType === CardType.Project || props.cardType === CardType.CommercialProject) && props.tagline;

  return (
    <Styled.CardWrapper>
      <Styled.SaveToListWrapper>
        <FavouritesToggle id={props.id} type={props.type} />
      </Styled.SaveToListWrapper>
      <Styled.CardInner>
        {props.imageWithTags}
        <Styled.PropertyDetailsWrapper data-auto="property-details">
          {propertyInfo}
        </Styled.PropertyDetailsWrapper>
      </Styled.CardInner>
      {tagline ? (
        <DiscountTagline weight="bold">{tagline}</DiscountTagline>
      ) : null}
    </Styled.CardWrapper>
  );
};

export default ListViewCard;
